import script from "./EventTicketShortModal.vue?vue&type=script&setup=true&lang=js"
export * from "./EventTicketShortModal.vue?vue&type=script&setup=true&lang=js"

import "./EventTicketShortModal.vue?vue&type=style&index=0&id=7e12b159&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e12b159"]])

export default __exports__